module.exports = ".leaflet-map{height:100%;width:100%;display:block}\n"